import {Disposable, Environment, graphql} from 'react-relay';
import Util from '../../forecast-app/shared/util/util';
import {trackAndCommitMutation} from '../../tracking/amplitude/TrackMutation';
import {MutationInput, RelayOnCompleted, RelayOnError} from '../MutationTypes';
import {AcquireReportLockInput, AcquireReportLockMutation} from './__generated__/AcquireReportLockMutation.graphql';

const mutation = graphql`
	mutation AcquireReportLockMutation($input: AcquireReportLockInput!) {
		acquireReportLock(input: $input) {
			token
			locked
			heldByViewer
			holder {
				id
				fullName
				profilePictureId
			}
			lockedAt
			expiresAt
		}
	}
`;

function commit(
	environment: Environment,
	input: MutationInput<AcquireReportLockInput>,
	onSuccess?: RelayOnCompleted<AcquireReportLockMutation>,
	onError?: RelayOnError
): Disposable {
	const variables = {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...input}};

	return trackAndCommitMutation(environment, {
		mutation,
		variables,
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
